import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import BigCar from '../game/BigCar';
import PatternCardItem from '../game/PatternCardItem';
import gameData, { GameVersions } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import PopOutButton from '../ui/PopOutButton';
import UIAssetKeys from '../UIAssetKeys';
import IntroScreen from './IntroScreen';

export default class EndScreen extends Phaser.Scene {
  static get KEY() { return 'EndScreen'; }

  constructor() {
    super({ key: EndScreen.KEY });
  }

  init() {
    this.cameras.main.setBackgroundColor(gameData.gameVersion === GameVersions.Number ? 0x6994CD : 0x5E2B85);

    this.goBtn = null;
    this.title1 = null;
    this.title1 = null;
    this.car = null;
    this.carDriving = null;
    this.carSpeed = null;
    this.carTarget = null;
    this.endCards = null;
    this.endTxt = null;
    this.endComplete = null;
    this.hasWheelie = null;

    this.engineSound = null;
  }

  create() {
    this.endComplete = false;
    this.hasWheelie = false;

    this.endCards = [];
    const m = gameData.gameVersion === GameVersions.Number ? Phaser.Math.Between(1,10) : ['circle','star','triangle']; ;
    const startX = 300;
    const spacing = 20;
    while (this.endCards.length < 3) {
      const card = new PatternCardItem(this,gameData.gameVersion === GameVersions.Number ? m * (1 + this.endCards.length) : m[this.endCards.length]);
      card.scale = 1.3;
      card.x = startX + (this.endCards.length * (card.getBounds().width + spacing));
      card.y = this.scale.height / 2 - 20;
      card.alpha = 0;
      this.add.existing(card);
      ABCyaPhaser.Tweens.addTween(card, 300, { delay: 100 * this.endCards.length, alpha: 1 }, Phaser.Math.Easing.Linear);
      this.endCards.push(card);
    }

    this.title1 = ABCyaPhaser.Images.addImage(this.scale.width * 0.7, 150, 'radical', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.title1.scaleX = 0;
    this.title1.alpha = 0;

    this.title2 = ABCyaPhaser.Images.addImage(this.scale.width * 0.7, this.title1.y + this.title1.height, 'you-crushed-it', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.title2.scaleX = 0;
    this.title2.alpha = 0;

    this.goBtn = new PopOutButton(this, 'next');
    this.goBtn.x = this.scale.width / 2;
    const bottomOffset = 35;

    // to use getBounds the scale needs to be 1
    this.goBtn.scale = 1;
    this.goBtn.y = this.scale.height - (this.goBtn.getBounds().width / 2) - bottomOffset;
    this.goBtn.scale = 0;
    this.add.existing(this.goBtn);

    this.car = new BigCar(this, 'large');
    this.car.x = -this.car.getBounds().width;
    this.car.y = this.endCards[0].y + (this.endCards[0].getBounds().height / this.endCards[0].scaleY) - this.car.carHeight;
    this.add.existing(this.car);

    this.time.delayedCall(100, this.startIntro, null, this);
  }

  startIntro () {
    // animate title
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._win_level, this);
    ABCyaPhaser.Tweens.addTween(this.title1, 1500, { delay: 500, scaleX: 1, alpha: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    ABCyaPhaser.Tweens.addTween(this.title2, 1500, { delay: 700, scaleX: 1, alpha: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);

    this.time.delayedCall(500, this.startCar, null, this);
  }

  startCar () {
    this.carSpeed = 7;
    this.carDriving = true;
    this.playEngineSound(SoundAssetKeys._car_rev_01, this);
  }

  playEngineSound (soundName) {
    if (this.engineSound !== null) {
      this.engineSound.destroy();
      this.engineSound = null;
    }
    this.engineSound = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(soundName, this.engineSound);
  }

  endReady () {
    this.goBtn.popIn();
    this.goBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.finishEnd, this);
  }

  finishEnd () {
    ABCyaPhaser.Tweens.addTween(this.title1, 1500, { delay: 500, scaleX: 0, alpha: 0, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    ABCyaPhaser.Tweens.addTween(this.title2, 1500, { delay: 700, scaleX: 0, alpha: 0, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);

    this.goBtn.popOut();

    // remove sample cards
    while (this.endCards.length > 0) {
      const c = this.endCards.shift();
      ABCyaPhaser.Tweens.addTween(c, 100, { alpha: 0 }, Phaser.Math.Easing.Linear, () => c.destroy());
    }

    // truck drive off
    ABCyaPhaser.Tweens.addTween(this.car, 300, { angle: 0, x: this.car.x + 50 }, Phaser.Math.Easing.Quadratic.Out, () => this.driveOff());

    this.playEngineSound(SoundAssetKeys._car_rev_01);
  }

  driveOff () {
    this.endComplete = true;
    this.carSpeed = 7;
    this.carDriving = true;
  }

  cleanUp () {
    if (this.engineSound !== null) {
      this.engineSound.destroy();
      this.engineSound = null;
    }
    this.scene.start(IntroScreen.KEY);
  }

  update () {
    // drive car here
    if (this.carDriving === true) {
      if (this.endComplete === false && this.carSpeed > 0 && this.car.x > this.endCards[0].x - this.car.getBounds().width + 150) {
        // drive up cards
        this.carDriving = false;
        this.endReady();
        this.playEngineSound(SoundAssetKeys._engine_stop);
      }
      else {
        if (this.car.x > this.scale.width) {
          this.carDriving = false;
          this.cleanUp();
        }
        else {
          if (this.hasWheelie === false && this.car.x > this.endCards[0].x - this.car.getBounds().width - 60) {
            this.hasWheelie = true;
            ABCyaPhaser.Tweens.addTween(this.car, 500, { angle: -35, y: this.car.y + (this.car.getBounds().height / 4) + 20 }, Phaser.Math.Easing.Quadratic.Out);
          }
          this.car.x += this.carSpeed;
          this.car.turnWheels(this.carSpeed);
        }
      }
    }
  }
}